import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabsHeader } from './tabs-header.tsx';

export type ITabLinkItem = {
    name: string;
    href: string;
    current?: boolean;
};

type Props = {
    tabs: ITabLinkItem[];
};

export function LinkTabs({ tabs }: Props) {
    const location = useLocation();
    const navigate = useNavigate();

    const asPath = location.pathname + location.search + location.hash;
    const tabsWithCurrent = tabs.map((tab) => ({
        ...tab,
        current: tab.current || asPath === tab.href,
    }));

    const newTabs = tabsWithCurrent.map((tab) => tab.name);
    const currentTab = tabsWithCurrent.find((tab) => tab.current);

    const selectedTabKey = useMemo(() => {
        return currentTab?.name ?? tabsWithCurrent[0]?.name ?? '';
    }, [currentTab, tabsWithCurrent]);

    const handleTabChange = (tabId: string) => {
        const tab = tabsWithCurrent.find((tab) => tab.name === tabId);

        if (tab && !tab.current) {
            return navigate(tab.href, { replace: true });
        }
    };

    return (
        <TabsHeader
            selectedTabKey={selectedTabKey}
            onTabChange={handleTabChange}
            tabs={newTabs}
            getTabLabel={(tabId) => tabId}
        />
    );
}
